module.exports = __webpack_public_path__ + "img/ic-protection.5787d3b0.svg";